import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\UpdateCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/UpdateCheckDepositController.php
* @route '/api/check-deposit/{check_deposit}'
*/
const UpdateCheckDepositController = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCheckDepositController.url(args, options),
    method: 'put',
})

UpdateCheckDepositController.definition = {
    methods: ["put"],
    url: '/api/check-deposit/{check_deposit}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\CheckDeposit\UpdateCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/UpdateCheckDepositController.php
* @route '/api/check-deposit/{check_deposit}'
*/
UpdateCheckDepositController.url = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { check_deposit: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { check_deposit: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            check_deposit: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        check_deposit: typeof args.check_deposit === 'object'
        ? args.check_deposit.id
        : args.check_deposit,
    }

    return UpdateCheckDepositController.definition.url
            .replace('{check_deposit}', parsedArgs.check_deposit.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\UpdateCheckDepositController::__invoke
* @see app/Http/Controllers/CheckDeposit/UpdateCheckDepositController.php
* @route '/api/check-deposit/{check_deposit}'
*/
UpdateCheckDepositController.put = (args: { check_deposit: string | number | { id: string | number } } | [check_deposit: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCheckDepositController.url(args, options),
    method: 'put',
})

export default UpdateCheckDepositController